// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "campaign_message".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { campaignChannelValues } from '@borradh-workspace/labels';
/** Response atom for the "campaign_message" table (1:1 with a DB row, on the wire). */
export const campaignMessageAtomSchema = z.object({
    id: z.string(),
    campaignId: z.string(),
    channel: z.enum(campaignChannelValues),
    subject: z.string().nullable(),
    body: z.string(),
    whatsappTemplateId: z.string().nullable(),
    whatsappTemplateParams: z.unknown().nullable(),
    mediaUrl: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=campaignMessage.js.map